module.exports = __webpack_public_path__ + "files/7aadce27db98cdbbda274a3ff1303862.png";